import { Injectable, inject } from '@angular/core';
import {
    IRelatedProductsCallback,
    IRelatedProductsOptions,
    RelatedProductsService
} from '@df/catalog-ui/related-products/related-products.service';
import { Category, ICategoryDataV3 } from '@df/catalog/category/category';
import { Model } from '@df/catalog/model';
import { IProductDataV3, Product } from '@df/catalog/product/product';
import { Meta } from '@df/core/meta/meta';
import { KlevuSearchService } from '@df/module-klevu-search/klevu-search.service';
import { KlevuSearch } from './klevu-interfaces';

@Injectable({
    providedIn: 'root'
})
export class KlevuContextRecommendationsEngine {
    private klevuSearchService = inject(KlevuSearchService);

    private meta = inject(Meta);

    private cache: { [context: string]: number[] } = {};

    async get(
        _ids: number[],
        callback: IRelatedProductsCallback,
        engineOptions: KlevuSearch.IContextRecommendationsOptions,
        _options: IRelatedProductsOptions
    ): Promise<void> {
        const model = this.meta.model;
        if (!model) {
            callback([]);
            return;
        }
        const cKey = [model.type, model.id, engineOptions.strategyId].join();
        try {
            if (!this.cache[cKey]) {
                this.cache[cKey] = await this.load(model, engineOptions);
            }
            callback(this.cache[cKey]);
        } catch (err) {
            callback([]);
        }
    }

    private async load(model: Model, engineOptions: KlevuSearch.IContextRecommendationsOptions): Promise<number[]> {
        const strategyId = engineOptions?.strategyId;
        if (strategyId) {
            if (model.type === 'product') {
                return this.klevuSearchService.loadContextRecommendationsForProduct(
                    strategyId,
                    this.klevuSearchService.getKlevuProductId(model as Product<IProductDataV3>),
                    (model as Product<IProductDataV3>).data!.parent
                );
            }

            if (model.type === 'category') {
                return this.klevuSearchService.loadContextRecommendationsForCategory(
                    strategyId,
                    this.klevuSearchService.getCategoryPath(model as Category<ICategoryDataV3>)
                );
            }
        }

        return [];
    }
}

RelatedProductsService.registerEngine(KlevuSearch.contextRecommendationsEngineId, KlevuContextRecommendationsEngine);
